enum SupportedCities {
  DUSSELDORF = 'Dusseldorf',
  COLOGNE = 'Cologne',
  // ESSEN = 'Essen',
}

export { SupportedCities };
